module.exports = __webpack_public_path__ + "media/phytic-large.89e7265c.mp4";